import { isRequested } from './isRequested'
import { BankingCard } from './types'

export const canRejectCard = (card: BankingCard | null | undefined): boolean => {
  return (
    !!(card?._policies?.approve?.can === true || card?.approval?._policies?.approveOrReject?.can) &&
    isRequested(card)
  )
}
